

<div class="mg-t-20 ">
  @if (totalObjectCount > 0) {
    <div class="pagination-wrapper">
      @if (pager.pages && pager.pages.length > 1) {
        <ul class="pagination mg-b-0">
          @if (currentPageNr != 1) {
            <li class="clickable page-item d-none d-sm-block" class.disabled="pager.currentPage === 1">
              <a class="page-link"(click)="doPage(1)" aria-label="First"><i class="fa fa-angle-double-left"></i></a>
            </li>
          }
          @for (page of pager.pages; track page; let idx = $index) {
            <li class="clickable page-item"  [class.active]="pager.currentPage === page">
              <a class="page-link" (click)="doPage(page)">{{page}}</a>
            </li>
          }
          @if (pager.currentPage != pager.totalPages) {
            <li class="clickable page-item d-none d-sm-block" >
              <a class="page-link" (click)="doPage(pager.totalPages)"><i class="fa fa-angle-double-right"></i></a>
            </li>
          }
        </ul>
      }
    </div>
  }

  @if (listCounts && totalObjectCount > pageSize) {
    <div class="pagination pagination-text">
      {{ getPaginationText() }}
    </div>
  }

  @if (resultsCapped === true) {
    <span class="pagination-text">
      {{ 'LISTVIEW.RESULTSCAPPED' | translate }}
    </span>
  }

</div>

